module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/doctor-4b2d4dff211b4d83b6a8d060cd530b54.svg";